'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  {\n    user {\n      userId\n      userName\n      bannerImageUrl\n      imageUrl\n      firstName\n      lastName\n      followers {\n        totalCount\n      }\n      isFollowingListPublic\n      isRegistered\n      subscriptions {\n        edges{\n          node{\n            status\n            expiresOn\n            providerId\n            providerName\n            key\n          }\n        }\n      }\n      email\n    }\n  }\n'], ['\n  {\n    user {\n      userId\n      userName\n      bannerImageUrl\n      imageUrl\n      firstName\n      lastName\n      followers {\n        totalCount\n      }\n      isFollowingListPublic\n      isRegistered\n      subscriptions {\n        edges{\n          node{\n            status\n            expiresOn\n            providerId\n            providerName\n            key\n          }\n        }\n      }\n      email\n    }\n  }\n']);

var _graphqlRequest = require('graphql-request');

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var me = (0, _graphqlRequest.gql)(_templateObject);

exports.default = {
  me: me
};
//# sourceMappingURL=user.js.map